import { render, staticRenderFns } from "./EditAppAffiliate.vue?vue&type=template&id=e1311374"
import script from "./EditAppAffiliate.vue?vue&type=script&lang=ts"
export * from "./EditAppAffiliate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports